<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name="QA_display_settings"
          @click="submit"
        >設定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">絞り込みの設定</span>
        </div>
        <div class="popup-content">
          <div class="list01">
            <SPCheckBoxTree
              :categories="narrow.userLists"
              :checked="narrow.userChecked"
              @checkSet="checkUpdate"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import * as _ from 'lodash'
import SPCheckBoxTree from '@/components/sp/partial/SPCheckBoxTree.vue'

export default defineComponent({
  name: 'SPNoteSearchExtract',
  props: {
    narrow: {
    }
  },
  components: {
    SPCheckBoxTree
  },
  setup (props, context) {
    const store = context.root.$store

    const checkUpdate = (checked, value, allId) => {
      (checked)
        ? props.narrow.userChecked = _.union(props.narrow.userChecked, allId)
        : props.narrow.userChecked = _.difference(props.narrow.userChecked, allId)
    }
    const close = () => {
      context.emit('closeNoteSearchExtract')
    }
    const submit = () => {
      // todo submit
      store.dispatch('note/reset')
      store.dispatch('note/setNarrowUsers', props.narrow.userChecked)
      store.dispatch('note/getNoteLists')
      store.dispatch('note/getNoteCount')
      context.emit('closeNoteSearchExtract')
      context.emit('submitNoteSearchExtract')
    }

    return {
      close,
      submit,
      checkUpdate
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
